var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoGuia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.073,
    height: 15,
    viewBox: "0 0 13.073 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icono_guia",
    "data-name": "icono guia",
    d: "M13.073,5v9.468c0,.484-.555.5-.8.353l-1.1-.663V5.939a.534.534,0,0,0-.283-.47C9.786,4.78,5.9,2.337,5.532,2.1c-1.95-1.218-3.067.137-2.178.717L8.19,5.748a.528.528,0,0,1,.254.452v8.272a.528.528,0,0,1-.8.452L3.188,12.23.255,10.456A.53.53,0,0,1,0,10V3.2C0,1.119,1.733.191,3.429.029A6.1,6.1,0,0,1,7.252.9l5.581,3.667a.525.525,0,0,1,.24.441",
    transform: "translate(0 0)",
    fill: "#d1077f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoGuia);
export default __webpack_public_path__ + "static/media/icono_guia.6da72d3aa1d74d406b46dd6a87080292.svg";
export { ForwardRef as ReactComponent };